import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * Page document interface
 */
export interface PageDocument extends BaseDocument {
  projectId: string
  parentPageId: string | null
  title: string
  slug: string
  icon: string | null
  iconType: string | null
  iconColor: string | null
  sortOrder: string | null
  coverImageUrl: string | null
  coverImageType: string | null
  coverImageMeta: string | null
}

/**
 * Page-specific hooks
 */
const hooks = createEntityHooks<PageDocument>('pages')

export const usePages = (filter?: Partial<PageDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { pages: data, isLoading, db }
}

export const useProjectPages = (projectId: string | undefined) => {
  const { pages, isLoading, db } = usePages()
  const projectPages = projectId
    ? pages?.filter((p) => p.projectId === projectId) ?? null
    : null
  return { pages: projectPages, isLoading, db }
}

export const usePage = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { page: data, isLoading }
}

export const usePageMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createPage: create,
    updatePage: update,
    deletePage: deleteEntity,
  }
}
